module.exports = __webpack_public_path__ + "img/img6.f2d822ef.png";